// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"622":"64d43f56","703":"80dd22b7"}[chunkId] + ".js";
};